import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { useExternalLinks } from '@/app/hooks/useExternalLinks';

import { LicensingAuthorityTypes } from '../models/licensingAuthority';

export const useLicensingAuthorityTypes = () => {
  const intl = useIntl();
  const links = useExternalLinks();

  return useMemo(
    () => [
      {
        title: intl.formatMessage({
          defaultMessage: 'TfL',
          id: 'VDbFyx',
          description: 'select option',
        }),
        value: LicensingAuthorityTypes.TFL,
        link: links.licensingAuthorityTFL,
      },
      {
        title: intl.formatMessage({
          defaultMessage: 'Royal Borough of Windsor and Maidenhead',
          id: 'q+N9ip',
          description: 'select option',
        }),
        value: LicensingAuthorityTypes.RBWM,
        link: links.licensingAuthorityRBWM,
      },
      {
        title: intl.formatMessage({
          defaultMessage: 'Castlepoint',
          id: 'CTRo8p',
          description: 'select option',
        }),
        value: LicensingAuthorityTypes.Castlepoint,
        link: links.licensingAuthorityCastlepoint,
      },
      {
        title: intl.formatMessage({
          defaultMessage: 'Hertsmere',
          id: 'onboarding_license_type_hertsmere',
          description: 'select option',
        }),
        value: LicensingAuthorityTypes.Hertsmere,
        link: links.licensingAuthorityHertsmere,
      },
      {
        title: intl.formatMessage({
          defaultMessage:
            'I have a Private Hire Operator’s Licence issued with different authority',
          id: 'onboarding_license_type_private',
          description: 'select option',
        }),
        value: LicensingAuthorityTypes.Other,
        link: null,
      },
    ],
    [intl, links],
  );
};
